import React from 'react';
import { IReceitaBrutaNCMReceber } from '../../../../../../../../../../../interfaces/IReceitaBruta';
import { Col, Row } from 'react-dsgov';
import styles from './itemReceitaBruta.module.scss';
import { formatCurrency } from '../../../../../../../../../../../utils/formatCurrency';
import { BrDivider } from '@govbr-ds/react-components';
import { formatNumber } from '../../../../../../../../../../../utils/formatNumber';

interface IItemReceitaBrutaProps {
  ncm: IReceitaBrutaNCMReceber;
}

const ItemReceitaBruta = ({ ncm }: IItemReceitaBrutaProps) => {
  return (
    <>
      <Row className={styles.row}>
        <Col>
          <span className={styles.label}>Código NCM</span>
          <p className={styles.text}>{ncm?.codigoNcm}</p>
        </Col>
        <Col>
          <span className={styles.label}>Unidade de Medida</span>
          <p className={styles.text}>{ncm?.unidadeMedida}</p>
        </Col>
        <Col>
          <span className={styles.label}>Receita Bruta de Venda (R$)</span>
          <p className={styles.text}>{formatCurrency(ncm?.valorReceitaBruta)}</p>
        </Col>
        <Col>
          <span className={styles.label}>Quantidade</span>
          <p className={styles.text}>{formatNumber(ncm?.quantidade)}</p>
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col>
          <span className={styles.label}>Preço Médio (R$)</span>
          <p className={styles.text}>{formatCurrency(ncm?.valorPrecoMedio)}</p>
        </Col>
        <Col>
          <span className={styles.label}>O bem mineral é oriundo de rejeitos?</span>
          <p className={styles.text}>{ncm?.isRejeito ? 'Sim' : 'Não'}</p>
        </Col>
        <Col>
          <span className={styles.label}>A substância possui uso específico?</span>
          <p className={styles.text}>{ncm?.hasUsoEspecifico ? 'Sim' : 'Não'}</p>
        </Col>
        <Col></Col>
      </Row>
      <div className={styles.movimentacao}>
        <Row>
          {ncm.tributosValores?.map((item) => (
            <Col key={item.nome} className={styles.tributosContainer}>
              <span className={styles.label}>{item.nome}</span>
              <p className={styles.text}>{formatCurrency(item.valor || '')}</p>
            </Col>
          ))}
        </Row>
        <div className={styles.metodoDivider}>
          <BrDivider />
        </div>
        <div className={styles.infoContainer}>
          <div>
            <span className={styles.label}>Receita Líquida (R$)</span>
            <p className={styles.text}>
              {formatCurrency(ncm?.valorReceitaBruta - ncm?.valorTotalTributosIncidentes || '')}
            </p>
          </div>

          <div>
            <span className={styles.label}>Quantidade a abater da aquisição de terceiros</span>
            <p className={styles.text}>{formatNumber(ncm?.quantidadeAquisicaoTerceiros)}</p>
          </div>
          <div>
            <span className={styles.label}>Valor total a abater da aquisição de terceiros (R$)</span>
            <p className={styles.text}>{formatCurrency(ncm?.valorAquisicaoTerceiros ?? '')}</p>
          </div>
        </div>
        <div className={styles.infoContainer}>
          <div>
            <span className={styles.label}>Deduções (R$)</span>
            <p className={styles.text}>{formatCurrency(ncm?.valorDeducoes ?? '')}</p>
          </div>
          <div>
            <span className={styles.label}>Base de Cálculo (R$)</span>
            <p className={styles.text}>{formatCurrency(ncm?.valorBaseCalculo ?? '')}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemReceitaBruta;
